<template>

    <!-- No free text search: everything worth filtering is in the search modal. -->

    <trax-ui-ajax-data-table
        :id="id" :titles="titles" :props="props" :cols="cols" :bus="bus"
        :endpoint="endpoint" order-column="4" order-dir="desc" searching="0">
    </trax-ui-ajax-data-table>

</template>

<script>
    export default {

        props: {
            bus: null,
            id: null,
            endpoint: null
        },

        data: function() {
            return {
                lang: lang,
                titles: [
                    lang.polaris.settings.task_author,
                    lang.polaris.settings.task_type,
                    lang.polaris.settings.task_scope,
                    lang.polaris.form.status,
                    lang.polaris.settings.task_date,
                    ''
                ],
                // The author, the task and the scope take what is left: their content is the least
                // predictable. The others are bounded by what they can display.
                props: [
                    {source: this.author},
                    {source: this.type},
                    {source: this.scope},
                    {source: this.status, width: '180px'},

                    // The date shown depends on the status, but the sorting stays on the request
                    // date: it is the only one every task has.
                    {source: this.date, order: 'created_at', width: '100px'},
                    {source: this.action, width: '50px', class: 'text-right'}
                ],
                cols: [
                    {},
                    {},
                    {},
                    {width: '180px'},
                    {width: '100px'},
                    {width: '50px', class: 'text-right'}
                ]
            }
        },

        // The rows are redrawn by datatables, so the handler is delegated to the table body.

        mounted: function() {
            var that = this;

            $('#'+this.id+'-table tbody').on('click', 'button.trax-task-cancel', function() {
                var row = $('#'+that.id+'-table').DataTable().row($(this).parents('tr')).data();
                if (row) {
                    that.bus.$emit(that.id+'-cancel-open', {data: row});
                }
            });
        },

        methods: {

            // Columns rendering

            author(data, type, row, meta) {
                return row.requester ? row.requester.name : '';
            },

            type(data, type, row, meta) {
                var label = this.lang.polaris.settings['task_type_' + row.type];
                return label ? label : row.type;
            },

            // A global task has no scope: the cell stays empty.
            scope(data, type, row, meta) {
                var html = row.user ? '<small>' + this.escape(row.user.name) + '</small>' : '';
                if (row.registration && row.registration.program) {
                    html += '<br><small class="text-muted">'
                        + this.escape(row.registration.program.name) + '</small>';
                }
                return html;
            },

            status(data, type, row, meta) {
                var label = this.lang.polaris.tasks[row.status];

                // A queued task says when it will be picked up: that is what the lane means.
                if (row.status == 'pending') {
                    label += ': ' + (row.lane == 'night'
                        ? this.lang.polaris.settings.task_lane_night
                        : this.lang.polaris.settings.task_lane_now);
                }

                var html = '<span class="badge ' + this.statusClass(row) + '">' + label + '</span>';

                if (row.status == 'running' && row.progress_total) {
                    html += ' <small>' + row.progress + '/' + row.progress_total + '</small>';
                }
                if (row.error) {
                    html += '<br><small class="text-danger">' + this.escape(row.error) + '</small>';
                }
                return html;
            },

            statusClass(row) {
                if (row.status == 'completed') return 'badge-success';
                if (row.status == 'failed') return 'badge-danger';
                if (row.status == 'running') return 'badge-info';
                if (row.status == 'cancelled') return 'badge-default';
                return 'badge-warning';
            },

            // The date which matters is the one the status refers to.
            date(data, type, row, meta) {
                var value = row.finished_at ? row.finished_at
                    : (row.started_at ? row.started_at : row.created_at);

                if (!value) {
                    return '';
                }
                return '<small>' + moment(value).format('DD/MM/YYYY') + '<br>'
                    + moment(value).format('H:mm:ss') + '</small>';
            },

            // Only a task which has not finished can be stopped.
            action(data, type, row, meta) {
                if (['pending', 'running', 'cancelling'].indexOf(row.status) < 0) {
                    return '';
                }
                return '<button type="button" class="btn btn-link btn-just-icon trax-task-cancel"'
                    + ' title="' + this.lang.polaris.tasks.cancel + '">'
                    + '<i class="material-icons">close</i></button>';
            },

            escape(value) {
                return $('<div>').text(value).html();
            }
        }

    }
</script>
